export default "__VITE_ASSET__8636c89e__"